import React from 'react';
import type { TooltipPrimitiveProps } from '@atlaskit/tooltip';
import { TooltipPrimitive } from '@atlaskit/tooltip';
import classNames from 'classnames';
import styles from './TooltipPrimitiveLight.less';

export const TooltipPrimitiveLight = React.forwardRef(
  (props: TooltipPrimitiveProps, ref: React.Ref<HTMLDivElement>) => {
    const { className, ref: wrongRef, ...rest } = props;
    return (
      <TooltipPrimitive
        className={classNames(className, styles.tooltipPrimitiveLight)}
        ref={ref}
        {...rest}
      />
    );
  },
);
